import BaseService from '@/ecm/common/BaseService.js'
import Utils from '@/ecm/common/Utils.js'

class LoggedUsersService {
  baseUrl = 'logged-users';

  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  delete = (id) => BaseService.post({ url: `${this.baseUrl}/delete/${id}` });
}

export default new LoggedUsersService()
